import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import LeaguesBase from './views/LeaguesBase.vue'
import LeaguesHome from './views/LeaguesHome.vue'
import Signup from './views/Signup.vue'
import SignupDetail from './views/SignupDetail.vue'
import SignupPayBase from './views/SignupPayBase.vue'
import SignupPay from './views/SignupPay.vue'
import SignupFinished from './views/SignupFinished.vue'
import SignupCampDetail from './views/SignupCampDetail.vue'
import SignupCampPay from './views/SignupCampPay.vue'
import SignupCampFinished from './views/SignupCampFinished.vue'
import Schedule from './views/Schedule.vue'
import ScheduleLeague from './views/Schedule.vue'
import ScheduleWeek from './views/Schedule.vue'
import ScheduleDay from './views/Schedule.vue'
import TournamentsBase from './views/TournamentsBase.vue'
import TournamentsHome from './views/TournamentsHome.vue'
import TournamentDetail from './views/TournamentDetail.vue'
import TournamentSignup from './views/TournamentSignup.vue'
import TournamentSignupPay from './views/TournamentSignupPay.vue'
import TournamentSignupFinished from './views/TournamentSignupFinished.vue'
import FrequentlyAskedQuestionsHome from './views/FrequentlyAskedQuestionsHome.vue'

Vue.use(Router)

export default new Router({
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/leagues',
      component: LeaguesBase,
      children: [
        {
          path: 'signup/:seasonId',
          name: 'signup',
          component: Signup
        },
        {
          path: 'signup/:seasonId/league/:leagueId',
          name: 'signup-detail',
          component: SignupDetail,
        },
        {
          path: 'signup/:seasonId/league/:leagueId/team/:pendingTeamId',
          component: SignupPayBase,
          children: [
            {
              path: 'pay',
              name: 'signup-pay',
              component: SignupPay,
            },
            {
              path: 'finished',
              name: 'signup-finished',
              component: SignupFinished,
            },
          ]
        },
        {
          path: 'signup/:seasonId/camp/:campId',
          name: 'signup-camp-detail',
          component: SignupCampDetail,
        },
        {
          path: 'signup/:seasonId/camp/:campId/camper/:camperId/pay',
          name: 'signup-camp-pay',
          component: SignupCampPay,
        },
        {
          path: 'signup/:seasonId/camp/:campId/camper/:camperId/finished',
          name: 'signup-camp-finished',
          component: SignupCampFinished,
        },
        {
          path: 'schedule/:seasonId',
          name: 'schedule',
          component: Schedule,
          children: [
            {
              path: 'league',
              name: 'schedule-league',
              component: ScheduleLeague
            },
            {
              path: 'week',
              name: 'schedule-week-number',
              component: ScheduleWeek
            },
            {
              path: 'day',
              name: 'schedule-day',
              component: ScheduleDay
            },
          ]
        },
        {
          path: '',
          name: 'leagues-home',
          component: LeaguesHome
        },
      ]
    },
    {
      path: '/tournaments',
      component: TournamentsBase,
      children: [
        {
          path: ':tournamentId/signup/:registrationId/pay',
          name: 'tournament-signup-pay',
          component: TournamentSignupPay
        },
        {
          path: ':tournamentId/signup/:registrationId/finished',
          name: 'tournament-signup-finished',
          component: TournamentSignupFinished
        },
        {
          path: ':tournamentId/signup',
          name: 'tournament-signup',
          component: TournamentSignup
        },
        {
          path: ':tournamentId/details',
          name: 'tournament-details',
          component: TournamentDetail
        },
        {
          path: '',
          name: 'tournaments-home',
          component: TournamentsHome
        },
      ]
    },
    {
      path: '/gallery',
      name: 'gallery',
      component: () => import('./views/GalleryHome.vue')
    },
    {
      path: '/faqs',
      name: 'faqs',
      component: FrequentlyAskedQuestionsHome
    },
  ]
})